import { KpiTileProps } from "./KpiTile";

type AggregationType = TestRequestRaw.Schemas.AggregationType;
type KpiKey = TestRequestRaw.Schemas.KpiKey;
type KpiValue = TestRequestRaw.Schemas.KpiValue;

const mappedKeys: KpiKey[] = ["REQUESTS", "PNS_POTENTIAL", "TIME_TO_MARKET"];

function mapToNumberOrNull(number: number | undefined): number | null {
  return typeof number === "number" ? number : null;
}

function mapUnit(unit: string | undefined): string | null {
  return unit === "EUR" ? "€" : unit || null;
}

function mapAggregationType(aggregationType: AggregationType): string {
  switch (aggregationType) {
    case "ABSOLUTE":
      return "Absolute";
    case "AVERAGE":
      return "Average";
    default:
      throw Error(`unmapped aggregation type: ${aggregationType}`);
  }
}

function mapTitle(kpiKey: KpiKey): string {
  switch (kpiKey) {
    case "PNS_POTENTIAL":
      return "PNS Potential";
    case "REQUESTS":
      return "Submitted Requests";
    case "TIME_TO_MARKET":
      return "Time to Market";
    default:
      throw Error(`unmapped kpi key: ${kpiKey}`);
  }
}

function mapKpiTileProp(kpiKey: KpiKey, kpiValue: KpiValue): KpiTileProps {
  return {
    key: kpiKey,
    total: mapToNumberOrNull(kpiValue.total),
    performance: mapToNumberOrNull(kpiValue.performance),
    yearToDate: mapToNumberOrNull(kpiValue.yearToDate),
    unit: mapUnit(kpiValue.unit),
    aggregationType: mapAggregationType(kpiValue.aggregationType),
    title: mapTitle(kpiKey),
    valuation: kpiValue.valuation,
  };
}

export default function mapKpiTileProps(kpiValues: Record<KpiKey, KpiValue>): KpiTileProps[] {
  return mappedKeys.filter((key) => Boolean(kpiValues[key])).map((key) => mapKpiTileProp(key, kpiValues[key]));
}
